module.exports = __webpack_public_path__ + "img/Gapp-logo.28abfe06.png";